<div class="question-group">

  <div class="top-question" (click)="toggleTop()">
    <input
      class="top-checkbox"
      type="checkbox"
      (click)="$event.stopPropagation()"
      [checked]="topChecked"
    />
    <span>{{ title }}</span>
  </div>

  <div class="sub-questions" *ngIf="topChecked">
    <div class="sub-item" *ngFor="let sub of subQuestions" (click)="toggleSub(sub)">
      <input class="sub-checkbox"
        type="checkbox"
        (click)="$event.stopPropagation()"
        [checked]="subChecked[sub]"
      />
      <span>{{ sub }}</span>
    </div>
  </div>

</div>
